import { render, staticRenderFns } from "./BlackListReport.vue?vue&type=template&id=3dc4b858"
import script from "./BlackListReport.vue?vue&type=script&lang=js"
export * from "./BlackListReport.vue?vue&type=script&lang=js"
import style0 from "./BlackListReport.vue?vue&type=style&index=0&id=3dc4b858&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports